var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-button',{attrs:{"name":"save"},nativeOn:{"click":function($event){return _vm.upload.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }